(function () {
    'use strict';

    angular.module("imApp").factory("equipmentGrpService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 2049,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2050,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
